module.exports = __webpack_public_path__ + "resources/img/img-hyper-frame-nginx-01-jp.93dd646b6b8c8faef80f88a1a06acd00.png";